// What the teacher is LOOKING AT, for Sandy. Pages publish their live view
// here (Monitor's session state, Intervene's on-screen student detail) and
// AIAssistant folds it into every request body, so Sandy answers from the
// screen's data instead of the hour-cached class briefing. Module-level like
// sandyChatStore because the publisher (page body) and the consumer (the
// chat, often mounted in the shell's aside or a floating window) are far
// apart in the tree.
//
// Contract: setSandyContext(key, value) publishes; value null still publishes
// ("there is explicitly nothing", e.g. Monitor with no session — Sandy should
// say so, not guess); clearSandyContext(key) on unmount removes the key so
// other pages never inherit stale context.

const ctx = new Map();

export function setSandyContext(key, value) {
  ctx.set(key, value);
}

export function clearSandyContext(key) {
  ctx.delete(key);
}

// Snapshot for one request. Keys with published-null survive (see contract);
// missing keys are simply absent from the body.
export function getSandyContext() {
  return Object.fromEntries(ctx.entries());
}
